import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { RouterModule } from '@angular/router';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ImageCropperModule } from 'ngx-image-cropper';
import { CoreModule } from '@teem/core/core.module';
import { NiceSelectModule } from 'ng-nice-select';

import { TeemappTableComponent } from '@teem/shared-component/teemapp-table/teemapp-table.component';
import { TeemappV2TableComponent } from '@teem/app/shared/components/teemapp-v2-table/teemapp-v2-table.component';
import { TeemappTableMenuComponent } from '@teem/shared-component/teemapp-table/teemapp-table-menu/teemapp-table-menu.component';
import { TeemappV2TableMenuComponent } from '@teem/shared-component/teemapp-v2-table/teemapp-v2-table-menu/teemapp-v2-table-menu.component';
import { StoreWelcomeComponent } from '@teem/shared-component/store-welcome/store-welcome.component';
import { ImageCropperPopupComponent } from '@teem/shared-component/image-cropper-popup/image-cropper-popup.component';
import { ViewInvoiceComponent } from '@teem/shared-component/view-invoice/view-invoice.component';
import { PdfViewInvoiceComponent } from '@teem/shared-component/pdf-view-invoice/pdf-view-invoice.component';
import { RefundPaymentModalComponent } from '@teem/shared-component/refund-payment-modal/refund-payment-modal.component';
import { SubscriptionPlanComponent } from '@teem/shared-component/subscription-plan/subscription-plan.component';
import { SubscriptionPlanFormComponent } from '@teem/shared-component/subscription-plan/forms/subscription-plan-form/subscription-plan-form.component';
import { NewActivationListComponent } from '@teem/shared-component/subscription-plan/new-activation-list/new-activation-list.component';
import { TopCustomersTableComponent } from '@teem/shared-component/subscription-plan/new-activation-list/top-customers-table/top-customers-table.component';
import { TopProductsTableComponent } from '@teem/shared-component/subscription-plan/new-activation-list/top-products-table/top-products-table.component';
import { LineChartComponent } from '@teem/shared-component/subscription-plan/new-activation-list/line-chart/line-chart.component';
import { RecentlyAddedProductsComponent } from '@teem/shared-component/subscription-plan/new-activation-list/recently-added-products/recently-added-products.component';
import { ApplePayComponent } from '@teem/shared-component/subscription-plan/apple-pay/apple-pay.component';
import { QrCodeModule } from 'ng-qrcode';
import { EditInvoiceComponent } from '@teem/shared-component/edit-invoice/edit-invoice.component';
import { DeliverableComponent } from '@teem/shared-component/deliverable/deliverable.component';
import { TagsInputComponent } from '@teem/shared-component/tags-input/tags-input.component';
import { AddCategoryModalComponent } from './components/add-category-modal/add-category-modal.component';
@NgModule({
  declarations: [
    TeemappTableComponent,
    TeemappTableMenuComponent,
    TeemappV2TableComponent,
    TeemappV2TableMenuComponent,
    StoreWelcomeComponent,
    ImageCropperPopupComponent,
    ViewInvoiceComponent,
    PdfViewInvoiceComponent,
    RefundPaymentModalComponent,
    SubscriptionPlanComponent,
    SubscriptionPlanFormComponent,
    NewActivationListComponent,
    TopCustomersTableComponent,
    TopProductsTableComponent,
    RecentlyAddedProductsComponent,
    LineChartComponent,
    ApplePayComponent,
    EditInvoiceComponent,
    DeliverableComponent,
    TagsInputComponent,
    AddCategoryModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    CoreModule,
    RouterModule,
    ImageCropperModule,
    NiceSelectModule,
    QrCodeModule
  ],
  exports: [
    TeemappTableComponent,
    TeemappTableMenuComponent,
    TeemappV2TableComponent,
    TeemappV2TableMenuComponent,
    StoreWelcomeComponent,
    ImageCropperPopupComponent,
    ViewInvoiceComponent,
    PdfViewInvoiceComponent,
    RefundPaymentModalComponent,
    SubscriptionPlanComponent,
    SubscriptionPlanFormComponent,
    NewActivationListComponent,
    TopCustomersTableComponent,
    TopProductsTableComponent,
    RecentlyAddedProductsComponent,
    LineChartComponent,
    ApplePayComponent,
    EditInvoiceComponent,
    DeliverableComponent,
    TagsInputComponent
  ]
})
export class SharedModule { }
